// @flow
import Entity from '../entity';

import { isNotEmpty, upperFirst, isFunction, contains } from '../utils';

import BaseController from '../players/base';
import StateEntity from '../state';

import $t from '../helpers/$t';

import type { Player$ExtensionOptions } from '../types/Options';
import type { Player$Translation } from '../types/Translation';

type Listener = {
   (event: string, ...args: Array<mixed>): mixed,
   _safe_inner? : boolean
}

export default class BaseExtension extends Entity {
   player: BaseController
   options: Player$ExtensionOptions
   state: StateEntity
   _events: string[]

   constructor(player: BaseController, state: StateEntity, options: Player$ExtensionOptions, events?: string[] = []) {
      super(options.bus, options.logger);
      this.player = player;
      this.options = options;
      this.state = state;

      this._events = events;

      const listener: Listener = this._listener.bind(this);
      listener._safe_inner = true; // eslint-disable-line camelcase

      if (isNotEmpty(events)) {
         // $FlowFixMe
         this._listener = listener;
         // $FlowFixMe
         this.bus.on('*', listener);
      }
   }

   $t(key: $Keys<Player$Translation>): string {
      const i18n = this.options.i18n;
      return $t(i18n, key);
   }

   _listener(event: string, ...args: Array<mixed>) {
      if (contains(this._events, event)) {
         const fncName = `on${upperFirst(event)}`;
         // $FlowFixMe
         const fnc = this[fncName];
         if (isFunction(fnc)) {
            fnc.apply(this, args);
         }
      }
   }

   destroy() {
      super.destroy();
      // $FlowFixMe
      this.bus.off('*', this._listener);
   }

   getElement(): ?HTMLElement {
      return null;
   }

   getOuter(): ?HTMLElement {
      return null;
   }
}
